export default "__VITE_ASSET__PQiy6kli__"